import React from 'react';
import { QueryKey } from 'react-query';
import includes from 'lodash/includes';

import { I18nText } from '../../../../../types';
import { UniversalFilterView } from '../../UniversalFilter.types';
import {
  UniversalFilterItemTagsValue,
  UniversalFilterItemTagsModes,
  UniversalFilterItemTagsFilterOptions,
  UniversalFilterItemTagsOnChange
} from './UniversalFilterItemTags.types';

import { useUniversalFilterItemTags } from './hooks/useUniversalFilterItemTags';

import { ItemTagsMultiSelect } from '../../../../../main/itemTags/helpers/ItemTagsMultiSelect';

import { UniversalFilterTemplate } from '../../helpers/UniversalFilterTemplate';

interface UniversalFilterItemTagsProps {
  filterView?: UniversalFilterView;
  filterStateCacheKey: QueryKey;
  filterValue?: UniversalFilterItemTagsValue;
  i18nName: I18nText;
  options?: UniversalFilterItemTagsFilterOptions;
  autoFocus?: boolean;
  onChange: UniversalFilterItemTagsOnChange;
}

function UniversalFilterItemTags({
  filterView,
  filterStateCacheKey,
  filterValue,
  i18nName,
  options,
  autoFocus,
  onChange
}: UniversalFilterItemTagsProps) {
  const { modeOptions, filterState, handleModeChange, handleUserIdsChange } =
    useUniversalFilterItemTags({ filterStateCacheKey, filterValue, onChange });

  return (
    <UniversalFilterTemplate<UniversalFilterItemTagsModes>
      filterView={filterView}
      i18nName={i18nName}
      selectedMode={filterState.mode}
      modeOptions={modeOptions}
      onModeChange={handleModeChange}
    >
      {includes(
        [
          UniversalFilterItemTagsModes.CONTAINS_ALL_OF
          // UniversalFilterItemTagsModes.DOES_NOT_CONTAIN_ANY_OF
        ],
        filterState.mode
      ) ? (
        <ItemTagsMultiSelect
          value={filterState.itemTagIds || []}
          initialFilters={options?.initialItemTagsFilters}
          autoFocus={autoFocus}
          inputWrapperClassName="block"
          onChange={handleUserIdsChange}
        />
      ) : null}
    </UniversalFilterTemplate>
  );
}

export default UniversalFilterItemTags;
